import * as React from 'react';
import { SVGProps } from 'react';

const SvgCovid19Faq = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M17.597 18.246c0-.576.077-1.036.192-1.382s.269-.653.422-.883c.154-.23.346-.422.576-.576.192-.154.384-.269.576-.422.154-.115.307-.269.422-.422s.192-.346.192-.576c0-.269-.115-.537-.307-.729s-.499-.307-.845-.307-.614.115-.883.307c-.23.192-.384.461-.499.729l-2.15-.96c.269-.691.691-1.229 1.305-1.612.576-.422 1.382-.614 2.38-.614.537 0 .998.077 1.459.23.422.154.806.384 1.113.653s.537.614.691.998c.154.384.269.806.269 1.267s-.077.845-.192 1.113c-.154.269-.307.537-.499.729s-.422.346-.691.499l-.691.461c-.192.154-.384.346-.499.576-.154.23-.192.537-.192.883v.077h-2.15v-.038zm1.037 3.647c-.422 0-.768-.115-1.036-.384s-.384-.614-.384-1.036.115-.768.384-1.075a1.416 1.416 0 0 1 1.036-.422c.461 0 .806.154 1.075.422s.384.614.384 1.075-.115.768-.384 1.036c-.269.269-.653.384-1.075.384z"
    />
    <path
      fill={props.fill}
      d="M27.847 34.6h-13.59v-3.801h10.096l3.493 3.801z"
    />
    <path
      fill="currentColor"
      d="M28.884 16.826v-.23c.038-5.874-4.607-10.595-10.404-10.595S8 10.723 8 16.558c0 4.261 2.495 7.947 6.257 9.597V30.8h2.073v-5.835l-.576-.154c-3.493-1.267-5.835-4.568-5.835-8.215 0-4.799 3.839-8.676 8.599-8.676s8.599 3.877 8.599 8.676v.422l1.881 4.722-2.035.077v2.918c0 1.344-1.075 2.188-2.803 2.188h-1.651V30.8h1.843v-1.881c2.649-.077 4.376-1.689 4.376-4.108v-1.19l2.879-.154-2.726-6.641z"
    />
  </svg>
);

export default SvgCovid19Faq;
